import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { SpinnerService } from 'src/app/services/spinner/spinner-service';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-spinner',
  imports: [AsyncPipe, ProgressSpinnerModule],
  templateUrl: './spinner.html',
  styleUrl: './spinner.scss'
})
export class Spinner {
  public spinner = inject(SpinnerService);
}
